import { Locale } from "@common/constans";
import Storage from "./Storage";

const Splash = () => { };

Splash.show = () => {
    document.documentElement.classList.add("has-splash");
}

Splash.hide = () => {
    document.documentElement.classList.remove("has-splash");
    const splashWrapper = document.getElementById('splashWrapper');
    splashWrapper?.style.setProperty('display', 'none');
}

Splash.error = () => {
    const error = document.getElementById("splashError");
    const lang = Storage.get("culture");
    if (error)
        error.innerHTML = lang === Locale.fa ?
            `
            <span>اشکال در دستیابی به سیستم</span>
            <br/>
            <span class="error-reload" onclick="window.location.reload()">تلاش مجدد</span>
            `
            :
            `
            <span>Error accessing website</span>
            <br/>
            <span class="error-reload" onclick="window.location.reload()">Reload</span>
            `;
    document.documentElement.classList.add("has-error");
}

export default Splash;
